// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__-k7yU","title":"NotFound_title__P5F9A","description":"NotFound_description__bgW0H","backButton":"NotFound_backButton__fIeCh"};